export const menuItems = [];